import * as v from "valibot";
import { passwordCase, passwordNumbers } from "helpers/password";

import { rpcContract } from "../rpc";

const createFanAccountParamsSchema = v.object({
  email: v.pipe(v.string(), v.email("Invalid email address")),
  password: v.pipe(
    v.string(),
    v.minLength(6, "Password must be at least 6 characters"),
    v.maxLength(64, "Password cannot exceed 64 characters"),
    v.regex(passwordNumbers, "Password must contain at least one number"),
    v.regex(passwordCase, "Password must contain at least one letter"),
  ),
  displayName: v.pipe(
    v.string(),
    v.minLength(1, "Display name is required"),
    v.maxLength(50, "Display name cannot exceed 50 characters"),
  ),
});

const createFanAccountResultSchema = v.object({
  user: v.object({
    id: v.string(),
    email: v.string(),
    name: v.string(),
  }),
  authToken: v.string(),
  sessionToken: v.string(),
});

export type CreateFanAccountParams = v.InferInput<typeof createFanAccountParamsSchema>;
export type CreateFanAccountResult = v.InferOutput<typeof createFanAccountResultSchema>;

export const createFanAccountRpcContract = rpcContract({
  name: "create-fan-account",
  paramsSchema: createFanAccountParamsSchema,
  resultSchema: createFanAccountResultSchema,
});
